import React from "react";

const TopLanguagePairsCard = ({ topLanguagePairs = [] }) => {
  const displayPairs = Array.isArray(topLanguagePairs) ? topLanguagePairs : [];

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
      <h3 className="text-xl font-bold text-gray-900 mb-5">Top Language Pairs Across All Services</h3>
      {displayPairs.length === 0 ? (
        <div className="py-12 text-center text-sm text-gray-500">
          No language pair usage recorded yet.
        </div>
      ) : (
        <div className="space-y-5">
          {displayPairs.map((item, idx) => (
            <div key={idx} className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm font-bold text-gray-900">{item.pair}</span>
                <div className="flex items-center gap-3">
                  <span className="text-sm font-medium text-gray-600">{item.count}</span>
                  {item.change && (
                    <span className="bg-emerald-50 text-emerald-600 text-xs font-semibold px-2 py-0.5 rounded-full">
                      {item.change}
                    </span>
                  )}
                </div>
              </div>
              <div className="w-full bg-gray-100 h-2 rounded-full overflow-hidden">
                <div
                  className="bg-[#1e6c56] h-full rounded-full transition-all duration-300"
                  style={{ width: `${item.percentage || 0}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TopLanguagePairsCard;
